module.exports = __webpack_public_path__ + "img/game12.8e03c4bf.png";